<template>
  <div>
    <vue-ueditor-wrap v-model="msg" :config="myConfig"></vue-ueditor-wrap>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap';

export default {
  components: {
    VueUeditorWrap,
  },

  data () {
    return {
      //新闻编辑器
      msg: '',
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: true,
        // 初始容器宽度
        initialFrameWidth: 1083,
        // 初始容器高度
        initialFrameHeight: 600,
        UEDITOR_HOME_URL: 'UEditor/',
        // 上传文件接口
        serverUrl: '/UEditor/php/controller.php'

      },
    }
  },
  watch: {
    msg:function(){
      this.$store.commit('setEditorContent', this.msg)
    },
  }
}
</script>

<style lang="scss" scoped>

</style>